<template>
	<div class="headers">
		<div class="user_box">
				<!-- width="200" -->
			<div class="img_box">
				<el-popover
					placement="top-start"
					popper-class="btn_signOut_box"
					trigger="hover">
					<span class="btn_signOut" @click="signOutFun()">{{$t('App.header.text1')}}</span>
				<img slot="reference" :src="avatar" @click="linkToFun('/dashboard')" :onError="imgErrorSrc">
				</el-popover>
			</div>
			<div class="text_box">
				<span>{{username}}</span>
			</div>
		</div>
		<div>
			<div class="top_logo_box" :class="{'edit':routerStr == '/siteManagement'}" @click="editHotelLogo()" v-if="domainName != 'elinker'">
				<img class="logo" :src="headerLogo?headerLogo:require('../img/top_webLogo.png')" :title="headerLogo">
                <img class="phone_icon" src="../img/phone_icon.png" />
			</div>

            <div class="top_logo_box elinker" v-if="domainName == 'elinker'">
                <img class="logo" src="../img/logo_yl.png">
            </div>
		</div>
		<div class="header_right">
			<template v-if="hotelIsShow">
				<el-dropdown @command="commandHotel" trigger="click" @visible-change="commandHide('dropdown_header_hotel')" v-if="hotelName&&routerStr!='/pushSetting'">
					<span class="el-dropdown-link">
						{{hotelName}}<i class="el-icon-caret-bottom el-icon--right"></i>
					</span>
					<el-dropdown-menu slot="dropdown" class="scrollbar_style dropdown_header_hotel">
						<el-dropdown-item v-for="item in hotelList" :class="{'select':item.id==hotelId}" :command="item" :key="item.id">{{item.name}}</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
				<el-dropdown @command="commandCity" trigger="click" @visible-change="commandHide('dropdown_header_city')" v-if="cityName">
					<span class="el-dropdown-link">
						{{cityName}}<i class="el-icon-caret-bottom el-icon--right"></i>
					</span>
					<el-dropdown-menu slot="dropdown" class="scrollbar_style dropdown_header_city">
						<el-dropdown-item v-for="item in cityList" :class="{'select':item.id==cityId}" :command="item" :key="item.id">{{item.name}}</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
				<el-dropdown @command="commandProvince" trigger="click" @visible-change="commandHide('dropdown_header_city')" v-if="provinceName">
					<span class="el-dropdown-link">
						{{provinceName}}<i class="el-icon-caret-bottom el-icon--right"></i>
					</span>
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item v-for="item in provinceList" :class="{'select':item.id==provinceId}" :command="item" :key="item.id">{{item.name}}</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
				<el-dropdown @command="commandCountry" trigger="click" @visible-change="commandHide('dropdown_header_city')" v-if="countryName">
					<span class="el-dropdown-link">
						{{countryName}}<i class="el-icon-caret-bottom el-icon--right"></i>
					</span>
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item v-for="item in countryList" :class="{'select':item.id==countryId}" :command="item" :key="item.id">{{item.name}}</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
			</template>
		</div>
	</div>
</template>

<script type="text/javascript">
    import allUrl from '../api/allUrl.js'
    import base from '../api/base.js'
    import { mapGetters } from 'vuex'

	export default {
		name:'headers',
		data(){
			return{
				countryList:[],
				provinceList:[],
				cityList:[],
				hotelList:[],
                imgErrorSrc:'',

                countryName:'Country',
                provinceName:'Province',
                cityName:'City',
                hotelName:'Hotel',


                longitude: 0,
                latitude: 0,
			}
		},
        computed:{
            ...mapGetters({
				token:'token',
				client_key:'client_key',
				username:'username',
				version:'version',

				countryId:'countryId',
				provinceId:'provinceId',
				cityId:'cityId',
				hotelId:'hotelId',
                hotelType:'hotelType',
                headerUpdate:'headerUpdate',
                headerIdStr:'headerIdStr',
                routerStr:'routerStr',
                headerLogo:'headerLogo',
                avatar:'avatar',
                domainName:'domainName',
            }),
            hotelIsShow(){
                let arr = ['/siteManagement','/userManagement','/activityHistory','/maintenanceStaff','/room-light','/circadianLightsPlan'];
                // console.log(this.routerStr)
                for(let val of arr){
                    if(this.routerStr == val){
                        return false
                    }
                }
                return true;
            },
        },
		mounted(){
            this.countryName = this.$t('App.header.text2');
            this.provinceName = this.$t('App.header.text3');
            this.cityName = this.$t('App.header.text4');
            this.hotelName = this.$t('App.header.text5');

            var storage = window.localStorage;
            this.imgErrorSrc = 'this.src="' + require('../img/user.jpg') + '"';
            // console.log(this.username)
			this.getCountryList(()=>{
				if(this.countryList.length > 0){
                    if(storage.getItem('countryIdNav')){
                        let isCountryId = true;
                        for(let d of this.countryList){
                            if(d.id == storage.getItem('countryIdNav')){
                                this.$store.commit('HEADERIDFUN',{
                                    countryId:d.id,
                                })
                                isCountryId = false;
                            }
                        }
                        if(isCountryId){
                            this.$store.commit('HEADERIDFUN',{
                                countryId:this.countryList[0].id,
                            })
                        }
                    }else{
                        this.$store.commit('HEADERIDFUN',{
                            countryId:this.countryList[0].id,
                        })
                    }
                    this.getProvinceList(()=>{
                        if(this.provinceList.length > 0){
                            if(storage.getItem('provinceIdNav')){
                                let isProvinceList = true;
                                for(let d of this.provinceList){
                                    if(d.id == storage.getItem('provinceIdNav')){
                                        this.$store.commit('HEADERIDFUN',{
                                            provinceId:d.id,
                                        })
                                        isProvinceList = false;
                                    }
                                }
                                if(isProvinceList){
                                    this.$store.commit('HEADERIDFUN',{
                                        provinceId:this.provinceList[0].id,
                                    })
                                }
                            }else{
                                this.$store.commit('HEADERIDFUN',{
                                    provinceId:this.provinceList[0].id,
                                })
                            }
                            this.getCityList(()=>{
                                if(this.cityList.length > 0){
                                    if(storage.getItem('cityIdNav')){
                                        let isCityId = true;
                                        for(let d of this.cityList){
                                            if(d.id == storage.getItem('cityIdNav')){
                                                this.$store.commit('HEADERIDFUN',{
                                                    cityId:d.id,
                                                })
                                                isCityId = false;
                                            }
                                        }
                                        if(isCityId){
                                            this.$store.commit('HEADERIDFUN',{
                                                cityId:this.cityList[0].id,
                                            })
                                        }
                                    }else{
                                        this.$store.commit('HEADERIDFUN',{
                                            cityId:this.cityList[0].id,
                                        })
                                    }
                                    this.getHotelList(this.cityId,()=>{
                                        // console.log(this.hotelList.length,storage.getItem('hotelIdNav'),'--------------')
                                        if(this.hotelList.length > 0){
                                            let isHotelId = true;
                                            if(storage.getItem('hotelIdNav')){
                                                for(let d of this.hotelList){
                                                    if(d.id == storage.getItem('hotelIdNav')){
                                                        this.$store.commit('HEADERIDFUN',{
                                                            hotelId:d.id,
                                                        })
                                                        this.$store.commit('HEADERLOGO',{
                                                            headerLogo: d.logo,
                                                        })
                                                        this.$store.commit('LONLATFUN',{
                                                            longitude: d.longitude,
                                                            latitude: d.latitude,
                                                        })
                                                        isHotelId = false;
                                                        this.$store.commit('HEADERIDFUN',{
                                                            hotelType: d.type,
                                                        })
                                                    }
                                                }
                                                // console.log(this.hotelId)
                                            }
                                            if(isHotelId){
                                                this.$store.commit('HEADERLOGO',{
                                                    headerLogo: this.hotelList[0].logo,
                                                })
                                                this.$store.commit('HEADERIDFUN',{
                                                    hotelId: this.hotelList[0].id,
                                                })
                                                this.$store.commit('LONLATFUN',{
                                                    longitude: this.hotelList[0].longitude,
                                                    latitude: this.hotelList[0].latitude,
                                                })
                                                this.$store.commit('HEADERIDFUN',{
                                                    hotelType: this.hotelList[0].type,
                                                })
                                            }
                                        }else{
                                            this.$store.commit('HEADERLOGO',{
                                                headerLogo: this.hotelList[0].logo,
                                            })
                                            this.$store.commit('HEADERIDFUN',{
                                                hotelId: this.hotelList[0].id,
                                            })
                                            this.$store.commit('LONLATFUN',{
                                                longitude: this.hotelList[0].longitude,
                                                latitude: this.hotelList[0].latitude,
                                            })
                                            this.$store.commit('HEADERIDFUN',{
                                                hotelType: this.hotelList[0].type,
                                            })
                                        }
                                    })
                                }else{
                                    this.$store.commit('HEADERIDFUN',{
                                        cityId:'',
                                    })
                                    this.cityName = '';
                                    // this.hotelName = '';
                                    this.getHotelList(this.provinceId,()=>{
                                        if(this.hotelList.length > 0){
                                            let isHotelId = true;
                                            if(storage.getItem('hotelIdNav')){
                                                for(let d of this.countryList){
                                                    if(d.id == storage.getItem('hotelIdNav')){
                                                        this.$store.commit('HEADERIDFUN',{
                                                            hotelId:d.id,
                                                        })
                                                        this.$store.commit('HEADERLOGO',{
                                                            headerLogo: d.logo,
                                                        })
                                                        this.$store.commit('LONLATFUN',{
                                                            longitude: d.longitude,
                                                            latitude: d.latitude,
                                                        })
                                                        isHotelId = false;
                                                        this.$store.commit('HEADERIDFUN',{
                                                            hotelType: d.type,
                                                        })
                                                    }
                                                }
                                            }
                                            if(isHotelId){
                                                this.$store.commit('HEADERLOGO',{
                                                    headerLogo: this.hotelList[0].logo,
                                                })
                                                this.$store.commit('HEADERIDFUN',{
                                                    hotelId: this.hotelList[0].id,
                                                })
                                                this.$store.commit('LONLATFUN',{
                                                    longitude: this.hotelList[0].longitude,
                                                    latitude: this.hotelList[0].latitude,
                                                })
                                                this.$store.commit('HEADERIDFUN',{
                                                    hotelType: this.hotelList[0].type,
                                                })
                                            }
                                        }else{
                                            this.$store.commit('HEADERLOGO',{
                                                headerLogo: this.hotelList[0].logo,
                                            })
                                            this.$store.commit('HEADERIDFUN',{
                                                hotelId: this.hotelList[0].id,
                                            })
                                            this.$store.commit('LONLATFUN',{
                                                longitude: this.hotelList[0].longitude,
                                                latitude: this.hotelList[0].latitude,
                                            })
                                            this.$store.commit('HEADERIDFUN',{
                                                hotelType: this.hotelList[0].type,
                                            })
                                        }
                                    })
                                }
                            })
                        }else{
                            this.$store.commit('HEADERIDFUN',{
                                provinceId:'',
                                cityId:'',
                            })
                            this.provinceName = '';
                            this.cityName = '';
                            // this.hotelName = '';
                            this.cityList = [];
                            this.getHotelList(this.countryId,()=>{
                                if(this.hotelList.length > 0){
                                    let isHotelId = true;
                                    if(storage.getItem('hotelIdNav')){
                                        for(let d of this.hotelList){
                                            // console.log(d,'-----------------',storage.getItem('hotelIdNav'))
                                            if(d.id == storage.getItem('hotelIdNav')){
                                                this.$store.commit('HEADERIDFUN',{
                                                    hotelId:d.id,
                                                })
                                                this.$store.commit('HEADERLOGO',{
                                                    headerLogo: d.logo,
                                                })
                                                this.$store.commit('LONLATFUN',{
                                                    longitude: d.longitude,
                                                    latitude: d.latitude,
                                                })
                                                isHotelId = false;
                                                this.$store.commit('HEADERIDFUN',{
                                                    hotelType: d.type,
                                                })
                                            }
                                        }
                                    }
                                    if(isHotelId){
                                        this.$store.commit('HEADERLOGO',{
                                            headerLogo: this.hotelList[0].logo,
                                        })
                                        this.$store.commit('HEADERIDFUN',{
                                            hotelId: this.hotelList[0].id,
                                        })
                                        this.$store.commit('LONLATFUN',{
                                            longitude: this.hotelList[0].longitude,
                                            latitude: this.hotelList[0].latitude,
                                        })
                                        this.$store.commit('HEADERIDFUN',{
                                            hotelType: this.hotelList[0].type,
                                        })
                                    }
                                }else{
                                    this.$store.commit('HEADERLOGO',{
                                        headerLogo: this.hotelList[0].logo,
                                    })
                                    this.$store.commit('HEADERIDFUN',{
                                        hotelId: this.hotelList[0].id,
                                    })
                                    this.$store.commit('LONLATFUN',{
                                        longitude: this.hotelList[0].longitude,
                                        latitude: this.hotelList[0].latitude,
                                    })
                                    this.$store.commit('HEADERIDFUN',{
                                        hotelType: this.hotelList[0].type,
                                    })
                                }
                            })
                        }
                    })
                }else{
                    this.$store.commit('HEADERIDFUN',{
                        countryId:'',
                        provinceId:'',
                        cityId:'',
                        hotelId:'',
                        headerIdStr:'',
                    })
                    this.countryName = '';
                    this.provinceName = '';
                    this.cityName = '';
                    this.hotelName = '';
                }
			});
		},
		methods:{
            editHotelLogo(){
                if(this.routerStr == '/siteManagement'){
                    this.$store.commit('EDITHOTELLOGOSHOW',{
                        editHotelLogoShow:'1',
                    })
                    this.$nextTick(function(){
                        this.$store.commit('EDITHOTELLOGOSHOW',{
                            editHotelLogoShowBg:'1',
                        })
                    })
                }
            },
            linkToFun(val){
                if(val != this.routerStr){
                    this.$router.push({path:val});
                    this.$store.commit('ROUTERSTRFUN',{
                        routerStr:val,
                    })
                    // if(this.version == '0'){
                    //     document.title = 'inHealth-'+val.split('/')[1]
                    // }
                    // if(this.version == '1'){
                    //     document.title = '工业照明-'+val.split('/')[1]
                    // }
                }
            },
            commandHide(val){
                this.$nextTick(function(){
                    if($('.'+val)&&$('.'+val+' >.select').offset()){
                        $('.'+val).animate({scrollTop: $('.'+val).scrollTop() + $('.'+val+' >.select').offset().top - $('.'+val).offset().top - 100})
                    }
                })
            },
            commandCountry(data){
                console.log(data.id,this.countryId)
                if(data.id!=this.countryId){
                    this.$store.commit('HEADERIDFUN',{
                        countryId: data.id,
                    })
                    this.getProvinceList(()=>{
                        if(this.provinceList.length > 0){
                            this.$store.commit('HEADERIDFUN',{
                                provinceId:this.provinceList[0].id,
                            })
                            this.getCityList(()=>{
                                if(this.cityList.length > 0){
                                    this.$store.commit('HEADERIDFUN',{
                                        cityId:this.cityList[0].id,
                                    })
                                    this.getHotelList(this.cityId,()=>{
                                        if(this.hotelList.length > 0){

                                            this.$store.commit('HEADERLOGO',{
                                                headerLogo: this.hotelList[0].logo,
                                            })
                                            this.$store.commit('HEADERIDFUN',{
                                                hotelId: this.hotelList[0].id,
                                            })
                                            this.$store.commit('LONLATFUN',{
                                                longitude: this.hotelList[0].longitude,
                                                latitude: this.hotelList[0].latitude,
                                            })
                                            this.$store.commit('HEADERIDFUN',{
                                                hotelType: this.hotelList[0].type,
                                            })
                                            if(this.hotelType == 0&&!(this.routerStr == '/classroomLights'||this.routerStr == '/blackboardLights'||this.routerStr == '/curtain'||this.routerStr == '/switchPanel')){
                                                this.linkToFun('/dashboard');
                                            }
                                        }
                                    })
                                }else{
                                    this.$store.commit('HEADERIDFUN',{
                                        cityId:'',
                                    })
                                    this.getHotelList(this.provinceId,()=>{
                                        if(this.hotelList.length > 0){

                                            this.$store.commit('HEADERLOGO',{
                                                headerLogo: this.hotelList[0].logo,
                                            })
                                            this.$store.commit('HEADERIDFUN',{
                                                hotelId: this.hotelList[0].id,
                                            })
                                            this.$store.commit('LONLATFUN',{
                                                longitude: this.hotelList[0].longitude,
                                                latitude: this.hotelList[0].latitude,
                                            })
                                            this.$store.commit('HEADERIDFUN',{
                                                hotelType: this.hotelList[0].type,
                                            })
                                            if(this.hotelType == 0&&!(this.routerStr == '/classroomLights'||this.routerStr == '/blackboardLights'||this.routerStr == '/curtain'||this.routerStr == '/switchPanel')){
                                                this.linkToFun('/dashboard');
                                            }
                                        }
                                    })
                                }
                            })
                        }else{
                            this.$store.commit('HEADERIDFUN',{
                                provinceId:'',
                                cityId:'',
                            })
                            this.cityList = [];
                            this.getHotelList(this.countryId,()=>{
                                if(this.hotelList.length > 0){

                                    this.$store.commit('HEADERLOGO',{
                                        headerLogo: this.hotelList[0].logo,
                                    })
                                    this.$store.commit('HEADERIDFUN',{
                                        hotelId: this.hotelList[0].id,
                                    })
                                    this.$store.commit('LONLATFUN',{
                                        longitude: this.hotelList[0].longitude,
                                        latitude: this.hotelList[0].latitude,
                                    })
                                    this.$store.commit('HEADERIDFUN',{
                                        hotelType: this.hotelList[0].type,
                                    })
                                    if(this.hotelType == 0&&!(this.routerStr == '/classroomLights'||this.routerStr == '/blackboardLights'||this.routerStr == '/curtain'||this.routerStr == '/switchPanel')){
                                        this.linkToFun('/dashboard');
                                    }
                                }
                            })
                        }
                    })
                }
            },
            commandProvince(data){
                if(data.id!=this.provinceId){
                    this.$store.commit('HEADERIDFUN',{
                        provinceId: data.id,
                    })
                    this.getCityList(()=>{
                        if(this.cityList.length > 0){
                            this.$store.commit('HEADERIDFUN',{
                                cityId:this.cityList[0].id,
                            })
                            this.getHotelList(this.cityId,()=>{
                                if(this.hotelList.length > 0){

                                    this.$store.commit('HEADERLOGO',{
                                        headerLogo: this.hotelList[0].logo,
                                    })
                                    this.$store.commit('HEADERIDFUN',{
                                        hotelId: this.hotelList[0].id,
                                    })
                                    this.$store.commit('LONLATFUN',{
                                        longitude: this.hotelList[0].longitude,
                                        latitude: this.hotelList[0].latitude,
                                    })
                                    this.$store.commit('HEADERIDFUN',{
                                        hotelType: this.hotelList[0].type,
                                    })
                                    if(this.hotelType == 0&&!(this.routerStr == '/classroomLights'||this.routerStr == '/blackboardLights'||this.routerStr == '/curtain'||this.routerStr == '/switchPanel')){
                                        this.linkToFun('/dashboard');
                                    }
                                }
                            })
                        }else{
                            this.$store.commit('HEADERIDFUN',{
                                cityId:'',
                            })
                            this.getHotelList(this.provinceId,()=>{
                                if(this.hotelList.length > 0){

                                    this.$store.commit('HEADERLOGO',{
                                        headerLogo: this.hotelList[0].logo,
                                    })
                                    this.$store.commit('HEADERIDFUN',{
                                        hotelId: this.hotelList[0].id,
                                    })
                                    this.$store.commit('LONLATFUN',{
                                        longitude: this.hotelList[0].longitude,
                                        latitude: this.hotelList[0].latitude,
                                    })
                                    this.$store.commit('HEADERIDFUN',{
                                        hotelType: this.hotelList[0].type,
                                    })
                                    if(this.hotelType == 0&&!(this.routerStr == '/classroomLights'||this.routerStr == '/blackboardLights'||this.routerStr == '/curtain'||this.routerStr == '/switchPanel')){
                                        this.linkToFun('/dashboard');
                                    }
                                }
                            })
                        }
                    })
                }
            },
            commandCity(data){
                if(data.id!=this.cityId){
                    this.$store.commit('HEADERIDFUN',{
                        cityId: data.id,
                    })
                    this.getHotelList(this.cityId,()=>{
                        if(this.hotelList.length > 0){

                            this.$store.commit('HEADERLOGO',{
                                headerLogo: this.hotelList[0].logo,
                            })
                            this.$store.commit('HEADERIDFUN',{
                                hotelId: this.hotelList[0].id,
                            })
                            this.$store.commit('LONLATFUN',{
                                longitude: this.hotelList[0].longitude,
                                latitude: this.hotelList[0].latitude,
                            })
                            this.$store.commit('HEADERIDFUN',{
                                hotelType: this.hotelList[0].type,
                            })
                            if(this.hotelType == 0&&!(this.routerStr == '/classroomLights'||this.routerStr == '/blackboardLights'||this.routerStr == '/curtain'||this.routerStr == '/switchPanel')){
                                this.linkToFun('/dashboard');
                            }
                        }
                    })
                }
            },
            commandHotel(data){
                if(data.id!=this.hotelId){

                    this.$store.commit('HEADERLOGO',{
                        headerLogo: data.logo,
                    })
                    this.$store.commit('HEADERIDFUN',{
                        hotelId: data.id,
                    })

                    this.$store.commit('LONLATFUN',{
                        longitude: data.longitude,
                        latitude: data.latitude,
                    })
                    if(this.hotelType!=data.type){
                        this.$store.commit('HEADERIDFUN',{
                            hotelType: data.type,
                        })
                        if(this.hotelType == 0&&!(this.routerStr == '/classroomLights'||this.routerStr == '/blackboardLights'||this.routerStr == '/curtain'||this.routerStr == '/switchPanel')){
                            this.linkToFun('/dashboard');
                        }else{
                            if(this.hotelType == 0){
                                if(this.routerStr == '/classroomLights'||this.routerStr == '/blackboardLights'||this.routerStr == '/curtain'||this.routerStr == '/switchPanel'){
                                    this.linkToFun('/lights');
                                }
                            }
                            if(this.hotelType == 1){
                                if(this.routerStr != '/classroomLights'&&this.routerStr != '/blackboardLights'&&this.routerStr != '/curtain'&&this.routerStr != '/switchPanel'){
                                    this.linkToFun('/classroomLights');
                                }
                            }
                        }
                    }else if(this.hotelType == 0&&!(this.routerStr == '/classroomLights'||this.routerStr == '/blackboardLights'||this.routerStr == '/curtain'||this.routerStr == '/switchPanel')){
                        this.linkToFun('/dashboard');
                    }
                }
            },
			signOutFun(){
                // base.setCookie('userData','')
                var storage = window.localStorage;
                storage.setItem('userData','');
                this.$store.commit('ROUTERSTRFUN',{
                  routerStr:'/login',
                })

                this.$store.commit('HEADERIDFUN',{
                    countryId:'',
                    provinceId:'',
                    cityId:'',
                    hotelId:'',
                    headerIdStr:''
                })

                // base.setCookie('hotelIdNav','');
                // base.setCookie('cityIdNav','');
                // base.setCookie('provinceIdNav','');
                // base.setCookie('countryIdNav','');
                storage.setItem('hotelIdNav','');
                storage.setItem('cityIdNav','');
                storage.setItem('provinceIdNav','');
                storage.setItem('countryIdNav','');
                this.$router.push({path:'/login'})
                // if(this.version == '0'){
                //     document.title = 'Inhealth-logo'
                // }
                // if(this.version == '1'){
                //     document.title = '工业照明-登录'
                // }
			},
            /*国家*/
			getCountryList(callback){
				base.ajax_post(
					allUrl.dashboard.countryList,
					{
						username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                    },
					{},
					data=>{
						this.countryList = data.data.list;
						if(callback){
							callback(data)
						}
					},
					this
				)
			},
			getProvinceList(callback){
				base.ajax_post(
					allUrl.dashboard.provinceList,
					{
						username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                        countryId:this.countryId
                    },
					{},
					data=>{
						this.provinceList = data.data.list;
						if(callback){
							callback(data)
						}
					},
					this
				)
			},
			getCityList(callback){
				base.ajax_post(
					allUrl.dashboard.cityList,
					{
						username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                        provinceId:this.provinceId,
                    },
					{},
					data=>{
						this.cityList = data.data.list;
						if(callback){
							callback(data)
						}
					},
					this
				)
			},
			getHotelList(cityId,callback){
				base.ajax_post(
					allUrl.dashboard.hotelList,
					{
						username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                        cityId:cityId,
                    },
					{},
					data=>{
						this.hotelList = data.data.list;
						if(callback){
							callback(data)
						}
					},
					this
				)
			},
			handleCommand(){

			}
        },
        watch:{
            countryId:function(){
                this.countryName = '';
                for(let d of this.countryList){
                    if(d.id == this.countryId){
                        this.countryName = d.name
                    }
                }
                // base.setCookie('countryIdNav',this.countryId);

                var storage = window.localStorage;
                storage.setItem('countryIdNav',this.countryId);

                this.$store.commit('HEADERIDFUN',{
                    headerIdStr: this.countryId+'_'+this.provinceId+'_'+this.cityId+'_'+this.hotelId,
                })
            },
            provinceId:function(){
                this.provinceName = '';
                for(let d of this.provinceList){
                    if(d.id == this.provinceId){
                        this.provinceName = d.name
                    }
                }
                // base.setCookie('provinceIdNav',this.provinceId);
                var storage = window.localStorage;
                storage.setItem('provinceIdNav',this.provinceId);
                this.$store.commit('HEADERIDFUN',{
                    headerIdStr: this.countryId+'_'+this.provinceId+'_'+this.cityId+'_'+this.hotelId,
                })
            },
            cityId:function(){
                this.cityName = '';
                for(let d of this.cityList){
                    if(d.id == this.cityId){
                        this.cityName = d.name
                    }
                }
                // base.setCookie('cityIdNav',this.cityId);
                var storage = window.localStorage;
                storage.setItem('cityIdNav',this.cityId);
                this.$store.commit('HEADERIDFUN',{
                    headerIdStr: this.countryId+'_'+this.provinceId+'_'+this.cityId+'_'+this.hotelId,
                })
            },
            hotelId:function(){
                console.log(this.hotelList,this.hotelId,'--------788---',this.hotelName)
                for(let d of this.hotelList){
                    if(d.id == this.hotelId){
                        this.hotelName = d.name;
                        // console.log(this.hotelType,d.type,this.routerStr)
                        // console.log(this.hotelType,d.type)
                        break;
                    }
                }
                // console.log(this.hotelList,this.hotelId,'--------788---',this.hotelName)
                // base.setCookie('hotelIdNav',this.hotelId);
                var storage = window.localStorage;
                storage.setItem('hotelIdNav',this.hotelId);
                this.$store.commit('HEADERIDFUN',{
                    headerIdStr: this.countryId+'_'+this.provinceId+'_'+this.cityId+'_'+this.hotelId,
                })
            },
            headerLogo:function(){
                console.log(this.headerLogo,'------------')
            },
            headerUpdate:function () {
                var storage = window.localStorage;
                console.log('headerUpdate')
                this.getCountryList(()=>{
                    if(this.countryList.length > 0){

                        if(storage.getItem('countryIdNav')){
                            let isCountryId = true;
                            for(let d of this.countryList){
                                if(d.id == storage.getItem('countryIdNav')){
                                    this.$store.commit('HEADERIDFUN',{
                                        countryId:d.id,
                                    })
                                    isCountryId = false;
                                }
                            }
                            if(isCountryId){
                                this.$store.commit('HEADERIDFUN',{
                                    countryId:this.countryList[0].id,
                                })
                            }
                        }else{
                            this.$store.commit('HEADERIDFUN',{
                                countryId:this.countryList[0].id,
                            })
                        }
                        this.getProvinceList(()=>{
                            if(this.provinceList.length > 0){
                                if(storage.getItem('provinceIdNav')){
                                    let isProvinceList = true;
                                    for(let d of this.provinceList){
                                        if(d.id == storage.getItem('provinceIdNav')){
                                            this.$store.commit('HEADERIDFUN',{
                                                provinceId:d.id,
                                            })
                                            isProvinceList = false;
                                        }
                                    }
                                    if(isProvinceList){
                                        this.$store.commit('HEADERIDFUN',{
                                            provinceId:this.provinceList[0].id,
                                        })
                                    }
                                }else{
                                    this.$store.commit('HEADERIDFUN',{
                                        provinceId:this.provinceList[0].id,
                                    })
                                }
                                this.getCityList(()=>{
                                    if(this.cityList.length > 0){
                                        if(storage.getItem('cityIdNav')){
                                            let isCityId = true;
                                            for(let d of this.cityList){
                                                if(d.id == storage.getItem('cityIdNav')){
                                                    this.$store.commit('HEADERIDFUN',{
                                                        cityId:d.id,
                                                    })
                                                    isCityId = false;
                                                }
                                            }
                                            if(isCityId){
                                                this.$store.commit('HEADERIDFUN',{
                                                    cityId:this.cityList[0].id,
                                                })
                                            }
                                        }else{
                                            this.$store.commit('HEADERIDFUN',{
                                                cityId:this.cityList[0].id,
                                            })
                                        }
                                        this.getHotelList(this.cityId,()=>{
                                            // console.log(this.hotelList.length)
                                            if(this.hotelList.length > 0){
                                                let isHotelId = true;
                                                if(storage.getItem('hotelIdNav')){
                                                    for(let d of this.hotelList){
                                                        if(d.id == storage.getItem('hotelIdNav')){
                                                            this.$store.commit('HEADERIDFUN',{
                                                                hotelId:d.id,
                                                            })
                                                            this.$store.commit('HEADERLOGO',{
                                                                headerLogo: d.logo,
                                                            })
                                                            this.$store.commit('LONLATFUN',{
                                                                longitude: d.longitude,
                                                                latitude: d.latitude,
                                                            })
                                                            isHotelId = false;
                                                        }
                                                    }
                                                }
                                                if(isHotelId){
                                                    this.$store.commit('HEADERLOGO',{
                                                        headerLogo: this.hotelList[0].logo,
                                                    })
                                                    this.$store.commit('HEADERIDFUN',{
                                                        hotelId: this.hotelList[0].id,
                                                    })
                                                    this.$store.commit('LONLATFUN',{
                                                        longitude: this.hotelList[0].longitude,
                                                        latitude: this.hotelList[0].latitude,
                                                    })
                                                }
                                            }else{
                                                this.$store.commit('HEADERLOGO',{
                                                    headerLogo: this.hotelList[0].logo,
                                                })
                                                this.$store.commit('HEADERIDFUN',{
                                                    hotelId: this.hotelList[0].id,
                                                })
                                                this.$store.commit('LONLATFUN',{
                                                    longitude: this.hotelList[0].longitude,
                                                    latitude: this.hotelList[0].latitude,
                                                })
                                            }
                                        })
                                    }else{
                                        this.$store.commit('HEADERIDFUN',{
                                            cityId:'',
                                        })
                                        this.cityName = '';
                                        // this.hotelName = '';
                                        this.getHotelList(this.provinceId,()=>{
                                            if(this.hotelList.length > 0){
                                                let isHotelId = true;
                                                if(storage.getItem('hotelIdNav')){
                                                    for(let d of this.countryList){
                                                        if(d.id == storage.getItem('hotelIdNav')){
                                                            this.$store.commit('HEADERIDFUN',{
                                                                hotelId:d.id,
                                                            })
                                                            this.$store.commit('HEADERLOGO',{
                                                                headerLogo: d.logo,
                                                            })
                                                            this.$store.commit('LONLATFUN',{
                                                                longitude: d.longitude,
                                                                latitude: d.latitude,
                                                            })
                                                            isHotelId = false;
                                                        }
                                                    }
                                                }
                                                if(isHotelId){
                                                    this.$store.commit('HEADERLOGO',{
                                                        headerLogo: this.hotelList[0].logo,
                                                    })
                                                    this.$store.commit('HEADERIDFUN',{
                                                        hotelId: this.hotelList[0].id,
                                                    })
                                                    this.$store.commit('LONLATFUN',{
                                                        longitude: this.hotelList[0].longitude,
                                                        latitude: this.hotelList[0].latitude,
                                                    })
                                                }
                                            }else{
                                                this.$store.commit('HEADERLOGO',{
                                                    headerLogo: this.hotelList[0].logo,
                                                })
                                                this.$store.commit('HEADERIDFUN',{
                                                    hotelId: this.hotelList[0].id,
                                                })
                                                this.$store.commit('LONLATFUN',{
                                                    longitude: this.hotelList[0].longitude,
                                                    latitude: this.hotelList[0].latitude,
                                                })
                                            }
                                        })
                                    }
                                })
                            }else{
                                this.$store.commit('HEADERIDFUN',{
                                    provinceId:'',
                                    cityId:'',
                                })
                                this.provinceName = '';
                                this.cityName = '';
                                // this.hotelName = '';
                                this.cityList = [];
                                this.getHotelList(this.countryId,()=>{
                                    if(this.hotelList.length > 0){
                                        let isHotelId = true;
                                        console.log(storage.getItem('hotelIdNav'),'-======')
                                        if(storage.getItem('hotelIdNav')){
                                            for(let d of this.hotelList){
                                                // console.log(d,'-----------------',storage.getItem('hotelIdNav'))
                                                if(d.id == storage.getItem('hotelIdNav')){
                                                    this.$store.commit('HEADERIDFUN',{
                                                        hotelId:d.id,
                                                    })
                                                    this.$store.commit('HEADERLOGO',{
                                                        headerLogo: d.logo,
                                                    })
                                                    this.$store.commit('LONLATFUN',{
                                                        longitude: d.longitude,
                                                        latitude: d.latitude,
                                                    })
                                                    isHotelId = false;
                                                }
                                            }
                                        }
                                        if(isHotelId){
                                            this.$store.commit('HEADERLOGO',{
                                                headerLogo: this.hotelList[0].logo,
                                            })
                                            this.$store.commit('HEADERIDFUN',{
                                                hotelId: this.hotelList[0].id,
                                            })
                                            this.$store.commit('LONLATFUN',{
                                                longitude: this.hotelList[0].longitude,
                                                latitude: this.hotelList[0].latitude,
                                            })
                                        }
                                    }else{
                                        this.$store.commit('HEADERLOGO',{
                                            headerLogo: this.hotelList[0].logo,
                                        })
                                        this.$store.commit('HEADERIDFUN',{
                                            hotelId: this.hotelList[0].id,
                                        })
                                        this.$store.commit('LONLATFUN',{
                                            longitude: this.hotelList[0].longitude,
                                            latitude: this.hotelList[0].latitude,
                                        })
                                    }
                                })
                            }
                        })
                    }else{
                        this.$store.commit('HEADERIDFUN',{
                            countryId:'',
                            provinceId:'',
                            cityId:'',
                            hotelId:'',
                            headerIdStr:'',
                        })
                        this.countryName = '';
                        this.provinceName = '';
                        this.cityName = '';
                        this.hotelName = '';
                    }
                });
            }
        }
	}
</script>

<style type="text/css" lang="less">
	.btn_signOut_box{
		&.el-popover{
			padding: 0;
			.btn_signOut{
				margin: 0 1rem;
				width: 10rem;height: 3.33rem;line-height: 3.33rem;
				text-align:center;
				font-family: AlibabaPuHuiTiM;
				font-size: 1rem;
				cursor: pointer;
			}
		}
	}
	.headers{
        position: fixed;
        top:0;left: 0;
        width: 100%;
        z-index: 2000;
		display: flex;
		justify-content: space-between;
		align-items: center;
		height: 4.17rem;line-height: 4.17rem;
		background: #FFFFFF;
		// box-shadow: 0 2px 6px 0 rgba(0,0,0,0.05);
        box-shadow:0rem 0.2rem 0.6rem 0rem rgba(0,0,0,0.05);
		.user_box{
			flex: 1;
			margin-left: 1.67rem;
			display: flex;
			.img_box{
				margin-top: 0.83rem;
				width: 2.5rem;height: 2.5rem;
				border-radius: 50%;
				overflow:hidden;
				img{
					width: 100%;
					height: 100%;
                    cursor: pointer;
				}
			}
			.text_box{
				margin-left: 1.25rem;
				font-family: AlibabaPuHuiTiM;
				font-size: 1rem;
				color: #333333;
				letter-spacing: 0;
				text-align: center;
			}
		}
		.top_logo_box{
			height: 1.4rem;line-height: 1.4rem;
            position: relative;
            &.elinker{
                height: 2.4rem;line-height:2.4rem;
            }
            &.edit{
                cursor: pointer;
                .phone_icon{
                    display: inherit;
                    height: 1.4rem;
                    position: absolute;
                    right: 0;bottom: -0.6rem;
                }
            }
            .phone_icon{
                display: none;   
            }
            .logo{
                height: 100%;
            }
		}
		.header_right{
			flex: 1;
			display: flex;
			flex-direction: row-reverse;
			.el-dropdown{
				margin-right: 1.67rem;
				font-family: AlibabaPuHuiTiR;
				font-size: 1rem;
				color: #333333;
				cursor: pointer;
			}
		}
	}
</style>